/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIRoleAutocompleteSuggestion
 */
export interface APIRoleAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIRoleAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIRoleAutocompleteSuggestion
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIRoleAutocompleteSuggestion
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRoleAutocompleteSuggestion
     */
    subRoleNames: Array<string>;
}

/**
 * Check if a given object implements the APIRoleAutocompleteSuggestion interface.
 */
export function instanceOfAPIRoleAutocompleteSuggestion(value: object): value is APIRoleAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('subRoleNames' in value) || value['subRoleNames'] === undefined) return false;
    return true;
}

export function APIRoleAutocompleteSuggestionFromJSON(json: any): APIRoleAutocompleteSuggestion {
    return APIRoleAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIRoleAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRoleAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'subRoleNames': json['sub_role_names'],
    };
}

export function APIRoleAutocompleteSuggestionToJSON(value?: APIRoleAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'sub_role_names': value['subRoleNames'],
    };
}

